export default __webpack_public_path__ + "static/FoodCutting-a765b842b942c4a712612bb65f35882c.png";